import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useAnalyticsLogging } from "../../Shared/hooks/useAnalyticsLogging/useAnalyticsLogging";
import { LoginRegisterShell } from "../LoginRegisterShell";
import { LoginForm } from "./LoginForm";
export const Login = () => {
    const { logReactPixelPageView, gaPageView } = useAnalyticsLogging();
    useEffect(() => {
        logReactPixelPageView();
        gaPageView("Login", location.pathname);
    }, []);
    return (_jsx(LoginRegisterShell, { children: _jsx(LoginForm, {}) }));
};
